import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import type { ChartOptions } from "chart.js";
import { Bar } from "react-chartjs-2";
import { ACTUAL_COLOR, GRID_COLOR, PROJECTION_COLOR, TICK_COLOR } from "./chartHelpers";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const options: ChartOptions<"bar"> = {
  responsive: true,
  maintainAspectRatio: true,
  aspectRatio: 2.4,
  scales: {
    x: { ticks: { color: TICK_COLOR }, grid: { display: false } },
    y: {
      ticks: { color: TICK_COLOR, callback: (v) => `${Number(v) > 0 ? "+" : ""}${v}%` },
      grid: { color: GRID_COLOR }
    }
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (item) => {
          const pct = item.parsed.y ?? 0;
          return `${pct > 0 ? "+" : ""}${pct.toFixed(1)}% vs average pace`;
        }
      }
    }
  }
};

type Props = {
  // Multiplier on the average kill pace per calendar month, Jan first
  factors: number[];
};

const SeasonChart = ({ factors }: Props) => {
  const pct = factors.map((f) => (f - 1) * 100);
  return (
    <Bar
      options={options}
      data={{
        labels: MONTHS,
        datasets: [
          {
            label: "Kill pace vs average",
            data: pct,
            backgroundColor: pct.map((p) =>
              p >= 0 ? PROJECTION_COLOR : ACTUAL_COLOR
            ),
            borderRadius: 3
          }
        ]
      }}
    />
  );
};

export default SeasonChart;
